import Alpine from 'alpinejs/dist/alpine.js'

window.Alpine = Alpine

Alpine.start()
